export const MEDIA_PREFIX = {
  IMAGES: 'data',
  VIDEO: 'media',
  SUBTITLES: 'media',
  RESOURCE: 'media',
}
